import { useToast } from "@/hooks/use-toast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast"

export function Toaster(): JSX.Element {
  const { toasts } = useToast()

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast key={id} {...props}>
            <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
            {action}
            <ToastClose />
          </Toast>
        )
      })}
      <ToastViewport className="fixed inset-x-4 bottom-4 z-[100] flex max-h-screen flex-col gap-2 p-4 pb-[calc(1rem+env(safe-area-inset-bottom,0px))] md:inset-auto md:bottom-auto md:right-4 md:top-[calc(1rem+env(safe-area-inset-top,0px))] md:pb-4" />
    </ToastProvider>
  )
}
